export enum TimerEvents {
  idleTimerInitiated = 'Idle Timer Initiated',
}
